import { Component } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { filter } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {
  clientVersion: string = '';
  assemblyDate: string = (() => {
    //const d = new Date(environment.releaseDate + 'T00:00:00');
    //return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    return environment.releaseDate;
  })();
}
